<template>
  <div class="card card-body shadow-lg sandbox">
    <h3> Sandbox</h3>
    <div class="row">
      <div class="form-group col-12 col-6-md">
        <label>Name</label>
        <input v-model="configApp.name" class="form-control" />
      </div>
      <div class="form-group col-6 col-md-3 col-lg-3">
        <label>Color</label>
        <input v-model="configApp.color_rgb" type="color" class="form-control" />
      </div>
      <div class="form-group col-6 col-md-3 col-lg-3">
        <label>Display</label>
        <select v-model="value.displayType" class="form-control">
          <option value="none">none</option>
          <option value="number">number</option>
          <option value="emoticon">emoticon</option>
        </select>
      </div>
      <div class="form-group col-6 col-md-3 col-lg-3">
        <label>Input</label>
        <select v-model="value.inputType" class="form-control">
          <option>arrow</option>
          <option>buttons</option>
          <option>slider</option>
          <option>enpsAarrow</option>
          <option>enpsButtons</option>
          <option>enpsSlider</option>
          <option>csat</option>
          <option>csat5Stars</option>
          <option>csat5Buttons</option>
          <option>esat</option>
          <option>esat5Stars</option>
          <option>esat5Buttons</option>
          <option>csat10</option>
          <option>csat10slider</option>
          <option>csat10arrow</option>
          <option>ces</option>
          <option>cesButtons</option>
          <option>cesStars</option>
          <option>ees</option>
          <option>eesButtons</option>
          <option>eesStars</option>
        </select>
      </div>
      <div class="form-group col-6 col-md-3 col-lg-3">
        <label>Classes</label>
        <select v-model="value.showClasses" class="form-control">
          <option :value="true">true</option>
          <option :value="false">false</option>
        </select>
      </div>
      <div class="form-group col-6 col-md-3 col-lg-3">
        <label>NPS Color</label>
        <select v-model="value.npsColor" class="form-control">
          <option :value="true">true</option>
          <option :value="false">false</option>
        </select>
      </div>
      <div class="form-group col-6 col-md-3 col-lg-3">
        <label>Comment</label>
        <select v-model="value.showComment" class="form-control">
          <option :value="true">true</option>
          <option :value="false">false</option>
        </select>
      </div>
      <div class="form-group col-6 col-md-3 col-lg-3">
        <label>E-mail Enrichment</label>
        <select v-model="value.showEmailEnrichment" class="form-control">
          <option :value="true">true</option>
          <option :value="false">false</option>
        </select>
      </div>
      <div class="form-group col-6 col-md-3 col-lg-3">
        <label>Document Enrichment</label>
        <select v-model="value.showDocumentEnrichment" class="form-control">
          <option :value="true">true</option>
          <option :value="false">false</option>
        </select>
      </div>
      <div class="form-group col-6 col-md-3 col-lg-3">
        <label>Phone Enrichment</label>
        <select v-model="value.showPhoneEnrichment" class="form-control">
          <option :value="true">true</option>
          <option :value="false">false</option>
        </select>
      </div>
      <div class="form-group col-6 col-md-3 col-lg-3">
        <label>Anonym</label>
        <select v-model="value.showAnonymous" class="form-control">
          <option :value="true">true</option>
          <option :value="false">false</option>
        </select>
      </div>
      <div class="form-group col-12 col-md-12 col-lg-12">
        <label>Custom Style</label>
        <textarea v-model="value.customStyle" class="form-control" />
      </div>
    </div>
  </div>
</template>
<script>
export default { props: ['value', 'configApp'] };
</script>
<style>
.sandbox label {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
